export const IMAGE_ALT = 'Banner Image';
